module.exports = InternalShared('InternalShared/PageBuilder/Controls/Core/styles/StyleManager');